import { parse } from 'tldts';

export function cleanSecretsFromUrl(url: string): string {
  try {
    const urlObject = new URL(url);
    const params = new URLSearchParams(urlObject.search);

    if (params.has('api_token')) {
      params.set('api_token', '***');
      urlObject.search = params.toString();
    }

    return urlObject.toString();
  } catch (e) {
    return url;
  }
}

export function removeUtmSourceFromUrl(url: string): string {
  try {
    const urlObject = new URL(url);
    const params = new URLSearchParams(urlObject.search);

    params.delete('utm_source');

    urlObject.search = params.toString();
    return urlObject.toString();
  } catch (e) {
    return url;
  }
}

/**
 * Clean utm_source parameters from URLs in markdown content
 * Uses a simple regex approach that's reliable and avoids complex AST manipulation
 * @param markdownContent - The markdown content containing URLs
 * @returns The markdown content with cleaned URLs
 */
export function cleanUtmSourceFromMarkdown(markdownContent: string): string {
  if (!markdownContent) {
    return markdownContent;
  }

  // Match markdown links: [text](url) and [text](url "title")
  const markdownLinkRegex = /\[([^\]]*)\]\(([^)\s]+)(?:\s+"[^"]*")?\)/g;

  return markdownContent.replace(markdownLinkRegex, (match, _linkText, url) => {
    const cleanedUrl = removeUtmSourceFromUrl(url);
    return match.replace(url, cleanedUrl);
  });
}

/**
 * Extract the top-level domain + extension from a URL
 * @param url - The URL to extract the domain from
 * @returns The top-level domain (e.g., "times.com", "bbc.co.uk") or the original URL if parsing fails
 */
export function extractTopDomainFromUrl(url: string): string {
  try {
    const urlObject = new URL(url);
    const hostname = urlObject.hostname;

    // Use tldts to parse the domain properly with Public Suffix List
    const parsed = parse(hostname);

    return parsed.domain || hostname;
  } catch (e) {
    return url;
  }
}
